__turbopack_context__.v({
  "buttonWrapper": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__buttonWrapper",
  "desktopGrid": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__desktopGrid",
  "desktopGridItem": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__desktopGridItem",
  "desktopSidebar": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__desktopSidebar",
  "desktopSidebarText": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__desktopSidebarText",
  "desktopView": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__desktopView",
  "mobileSlide": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__mobileSlide",
  "mobileTextBlock": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__mobileTextBlock",
  "mobileTitleBlock": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__mobileTitleBlock",
  "mobileView": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__mobileView",
  "sectionSubtitle": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__sectionSubtitle",
  "sectionTitle": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__sectionTitle",
  "swiperFull": "ArticleOrEventRecommendation-module-scss-module__5jLzKG__swiperFull",
});
